module.exports = __webpack_public_path__ + "img/social-instagram.48265496.svg";